const microtime = () => {
    return (+ new Date()) / 1000;
};

export default microtime;
